import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class GeneralConfigurationServices {
  /**
     *
     * @param {*} payload
     * @return
     */
     updateGeneralConfiguration = async (payload) => {
       const generalConfiguration = await Helpers.post({
         url: Constants.GENERAL_CONFIGURATION,
         data: payload,
       });
       return generalConfiguration;
     }

     /**
      *
      * @param {*} entityType
      * @return
      */
    getGeneralConfiguration = async (entityType) => {
      let url = `${Constants.GENERAL_CONFIGURATION}?`;
      if (entityType) url += `entity_name=${entityType}`;
      const generalConfiguration = await Helpers.get({ url });
      return generalConfiguration;
    }
}
export default new GeneralConfigurationServices();
